import { render, staticRenderFns } from "./NotAccessToAdmin.vue?vue&type=template&id=7406e549&scoped=true&"
import script from "./NotAccessToAdmin.vue?vue&type=script&lang=js&"
export * from "./NotAccessToAdmin.vue?vue&type=script&lang=js&"
import style0 from "./NotAccessToAdmin.vue?vue&type=style&index=0&id=7406e549&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7406e549",
  null
  
)

export default component.exports